module.exports = __webpack_public_path__ + "static/img/clause_confirmation102.86136ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation102.png
// module id = JMqW
// module chunks = 1